import { queryOptions, skipToken, useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { groupScheme } from '@/models/group/group-info';
import { responseScheme } from '@/models/response';
import { fetcher } from '@/utils/fetcher';

export const generateGroupInfoByQRCodeQueryOptions = (code: Nullable<string>) =>
  queryOptions({
    queryKey: ['/GetGroupInfoByQRCode', code],
    queryFn: code
      ? ({ signal }) =>
          fetcher<GroupInfoByQRCode>(
            '/GetGroupInfoByQRCode',
            { GroupQRCode: code },
            { signal, schema: groupInfoByQRCodeScheme, validResponseCodes: [0] },
          )
      : skipToken,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: false,
  });

export function useGroupByCode(code: string | null | undefined) {
  return useQuery(generateGroupInfoByQRCodeQueryOptions(code));
}

const groupInfoByQRCodeScheme = responseScheme.merge(z.object({ GroupData: groupScheme }));

type GroupInfoByQRCode = z.infer<typeof groupInfoByQRCodeScheme>;
